import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CotizacionesCondicionesService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  dataSource(varArgs : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cotizaciones/Condiciones/DataSource", varArgs, Sessions.header());
  }

  store(objCotizacionCondicion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cotizaciones/Condiciones/Store", objCotizacionCondicion, Sessions.header());
  }

  update(objCotizacionCondicion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cotizaciones/Condiciones/Update", objCotizacionCondicion, Sessions.header());
  }

  delete(objCotizacionCondicion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cotizaciones/Condiciones/Delete", objCotizacionCondicion, Sessions.header());
  }

}